import React, { lazy, Suspense, useEffect, useState } from 'react';
import RegularButton from '../../components/CustomButtons/Button';
import NavPills from '../../components/NavPills/NavPills';
import YourInventory from './YourInventory';
import { useSelector } from "react-redux";

export default function Stockroom() {
  const storeID = useSelector(state => state.app.activeStore)
  return (
    <div>
      <NavPills
        color="primary"
        tabs={[
          {
            tabButton: 'Your Inventory',
            tabContent: (
              <YourInventory />
            )
          },
          {
            tabButton: 'Featured',
            tabContent: (
              <YourInventory
                showAllItems={true}
                recommended={true}
              />
            )
          },
          {
            tabButton: 'All',
            tabContent: (
              <YourInventory
                showAllItems={true}
              />
            )
          },{
            tabButton: <RegularButton color='primary'>
              Add New Product
            </RegularButton>,
            tabContent: null,
            styleOverride: {position: 'absolute', bottom: 0, right: 0},
            onClick: () => {
              window.open(`https://docs.google.com/forms/d/e/1FAIpQLSeILWz7jdYQJ6tk7jxA1kCCnN0MLCHsv5hiJOqyXqAbFvtFTw/viewform?entry.930969771=${storeID}`);
            }
          }
        ]}
      />

    </div>
  );
}
